/**
 * Helpers to make easier serialize data e retrive from localStorage
 */
export const localStorage = {
  get<T>(key: string): T | undefined {
    const value = window.localStorage.getItem(key)

    if (value == null) {
      return undefined
    }
    try {
      return JSON.parse(value) as T
    } catch (error) {
      return value as T
    }
  },

  set<T>(key: string, value: T, jsonParse = true) {
    window.localStorage.setItem(key, jsonParse ? JSON.stringify(value) : (value as string))
  },

  remove(key: string) {
    window.localStorage.removeItem(key)
  },
}
